import React, { ChangeEvent, KeyboardEvent, forwardRef } from "react";
import { CircularProgress, IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import classes from "./global-search.module.css";

interface GlobalSearchInputProps {
  value: string;
  isLoading: boolean;
  placeholder?: string;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
  onFocus: () => void;
  onClear: () => void;
}

const GlobalSearchInput = forwardRef<HTMLDivElement, GlobalSearchInputProps>(
  (props, ref) => {
    const { value, isLoading, placeholder, onChange, onKeyDown, onFocus, onClear } = props;

    return (
      <TextField
        ref={ref}
        size="small"
        fullWidth
        className={classes.input}
        placeholder={placeholder}
        value={value}
        name="globalSearch"
        autoComplete="off"
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        inputProps={{ "aria-label": "Global search", "test-id": "global-search-input" }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {isLoading ? (
                <CircularProgress size={18} />
              ) : value ? (
                <IconButton
                  size="small"
                  aria-label="Clear search"
                  onClick={onClear}
                  edge="end"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ) : null}
            </InputAdornment>
          ),
        }}
      />
    );
  }
);

GlobalSearchInput.displayName = "GlobalSearchInput";

export default GlobalSearchInput;
